var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.034 30.6834C18.4673 30.8834 17.534 30.8834 16.9673 30.6834C12.134 29.0334 1.33398 22.1501 1.33398 10.4834C1.33398 5.33341 5.48398 1.16675 10.6007 1.16675C13.634 1.16675 16.3173 2.63342 18.0007 4.90008C19.684 2.63342 22.384 1.16675 25.4007 1.16675C30.5173 1.16675 34.6673 5.33341 34.6673 10.4834C34.6673 22.1501 23.8673 29.0334 19.034 30.6834Z",
    fill: "#161623",
    stroke: "#161623",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteSelected);
export default __webpack_public_path__ + "static/media/favorite-selected.a2b9aea294435bf25b523307e8e3fddd.svg";
export { ForwardRef as ReactComponent };